import { PLATFORM_LABELS, PROVIDER_TO_PLATFORMS } from '../../../../constants/selectLists/platformList'

export const getFormattedProviders = providers => {
  if (!providers) {
    return []
  }

  return providers.map(provider => PLATFORM_LABELS[PROVIDER_TO_PLATFORMS[provider]])
}

export const generateLabelsText = (labels, connectionWord = 'and') => {
  if (!labels?.length) {
    return ''
  } else if (labels.length === 1) {
    return labels[0]
  } else if (labels.length === 2) {
    return labels.join(` ${connectionWord} `)
  } else {
    const lastLabel = labels.pop()
    return labels.join(', ') + ` ${connectionWord} ` + lastLabel
  }
}
